export default {
  header: {
    projectName: 'Project Name',
    export: 'Export',
    debug: 'Debug',
    success: 'Success',
    failed: 'Failed',
    generating: 'Generating video...',
    updateNameFailed: 'Failed to update project name',
    menu: 'Menu',
    settings: 'Settings',
    shortcuts: 'Keyboard Shortcuts',
    about: 'About',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    settingsComingSoon: 'Settings feature coming soon',
    shortcutsComingSoon: 'Keyboard shortcuts feature coming soon',
    aboutComingSoon: 'About information coming soon',
    language: 'Language',
    dimensions: 'Dimensions',
    canvas: 'Canvas',
    view: 'View',
    general: 'General'
  },
  menu: {
    media: 'Media',
    text: 'Text'
  },
  loading: {
    core: 'Core Loading...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: 'Public Beta',
    betaDisclaimer: 'Beta version, data persistence not guaranteed',
    newProject: 'New Project',
    backupFolder: 'Backup Folder',
    documentation: 'Documentation',
    recentProjects: 'Recent Projects',
    viewAll: 'View all ({count})',
    noProjects: 'No projects yet. Create your first project to get started!',
    login: 'LOG IN',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: 'BLOG',
    projectCreated: 'Project Created',
    projectCreatedDesc: 'New project created successfully',
    projectDeleted: 'Project Deleted',
    projectDeletedDesc: 'Project deleted successfully',
    deleteConfirmation: 'Are you sure you want to delete this project? This action cannot be undone.',
    migrationFailed: 'Migration Failed',
    migrationFailedDesc: 'Failed to migrate data from localStorage',
    loadFailed: 'Load Failed',
    loadFailedDesc: 'Failed to load projects',
    creationFailed: 'Creation Failed',
    creationFailedDesc: 'Failed to create new project',
    deletionFailed: 'Deletion Failed',
    deletionFailedDesc: 'Failed to delete project'
  },
  timeline: {
    autoSaveFailed: 'Auto-save failed',
    autoSaveFailedDesc: 'Failed to auto-save project',
    loadFailed: 'Load Failed',
    loadFailedDesc: 'Failed to load project. Redirecting to home...',
    mainTrack: 'Main Track',
    undo: 'Undo',
    redo: 'Redo',
    split: 'Split',
    delete: 'Delete'
  },
  attributes: {
    properties: 'Properties',
    position: 'Position',
    scale: 'Scale',
    animation: 'Animation',
    basic: 'Basic',
    mute: 'Mute',
    text: 'Text',
    fontSize: 'Font Size',
    content: 'Content',
    fontFamily: 'Font Family',
    direction: 'Text Direction',
    color: 'Color',
    stroke: 'Stroke',
    background: 'Background',
    video: 'Video',
    rotate: 'Rotate',
    backgroundColor: 'Background Color',
    opacity: 'Opacity',
    blend: 'Blend',
    filter: 'Filter',
    effect: 'Effect',
    transition: 'Transition',
    speed: 'Speed',
    volume: 'Volume'
  },
  router: {
    timeline: 'Timeline',
    preview: 'Preview',
    storyboard: 'Storyboard - AI Video Agent'
  },
  placeholder: {
    text: 'Please enter text content',
    input: 'Please enter'
  },
  error: {
    parseAudio: 'Failed to parse audio',
    parseImage: 'Failed to parse image',
    parseVideo: 'Failed to parse video',
    noProject: 'Please create or open a project first',
    invalidFileType: 'Invalid file type'
  },
  media: {
    video: 'Video',
    image: 'Image',
    audio: 'Audio',
    dropToUpload: 'Drop files here to upload'
  },
  common: {
    defaultText: 'Default Text'
  }
};
